import Vue from 'vue'
import App from './App.vue'

import { sync } from 'vuex-router-sync'

import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import '@/plugins/firebase'
import '@/plugins/flash'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { VueMaskDirective } from 'v-mask'

// https://github.com/vuejs/vuex-router-sync
sync(store, router)

// Disable production tips
Vue.config.productionTip = false

// Vue directives
Vue.directive('mask', VueMaskDirective)

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
